export class Collection {
  
  getAutoRoute() {
    return this.config.autoRoute;
  }
  
  getKey() {
    return this.config.key;
  }
  
  getSingleLabel(lowercase = false) {
    return lowercase ? this.config.singleLabel.toLowerCase() : this.config.singleLabel;
  }
  
  getPluralLabel(lowercase = false) {
    return lowercase ? this.config.pluralLabel.toLowerCase() : this.config.pluralLabel;
  }
  
  getIndexUrl() {
    return this.config.indexUrl;
  }
  
  getCreateUrl() {
    return this.config.createUrl;
  }
  
  getSearchKeys() {
    return this.config.searchKeys;
  }
  
  getEditUrl(item) {
    return `${this.config.editUrlPrefix}/${item[this.config.idKey]}`;
  }
  
  getEditUrlPrefix(item) {
    return this.config.editUrlPrefix;
  }
  
  getName(item) {
    if (!item) { return null; }
    
    return item[this.config.nameKey];
  }
  
  getApiIndexEndpoint() {
    return this.config.payloadEndpoint;
  }
  
  getApiObjectEndpoint(id) {
    return `${this.config.payloadEndpoint}/${id}`;
  }
  
  getDefaultSort() {
    return this.config.defaultSort;
  }
  
  getIndexColumns() {
    return this.config.indexColumns;
  }
  
  getId(item) {
    if (!item) { return null; }
    
    return item[this.config.idKey];
  }
  
  getIdKey(item) {
    return this.config.idKey;
  }
  
  getIndexFilters(item) {
    return this.config.indexFilters;
  }
  
  getCreateFormFields() {
    return this.config.createFormFields;
  }
  
  getCreateFormContexts() {
    if (!this.config.createFormContexts) {
      return [];
    }
    
    return this.config.createFormContexts;
  }
  
  getEditFormFields() {
    return this.config.editFormFields;
  }
  
  getIndexPageComponent() {
    return this.config.indexPageComponent || null;
  }
  
  getCreatePageComponent() {
    return this.config.createPageComponent || null;
  }
  
  getEditPageComponent() {
    return this.config.editPageComponent || null;
  }
  
  getIndexContextFilters() {
    if (!this.config.indexContexts) {
      return [];
    }
    
    return this.config.indexContexts;
  }
  
  getIndexSelects() {
    if (!this.config.indexSelects) {
      return null;
    }
    
    return this.config.indexSelects;
  }
  
  getRequiresOrganisation() {
    return this.config.requiresOrganisation || false;
  }
  
  getRequiresSuperAdmin() {
    return this.config.requiresSuperAdmin || false;
  }
  
  getRedirectAfterCreate(item) {
    return this.getIndexUrl();
  }
  
  getRedirectAfterEdit(item) {
    return null;
  }
  
}